module.exports = __webpack_public_path__ + "img/cryptoNotesProject.338db6ce.jpeg";